export default __webpack_public_path__ + "greydot.6749dc39.svg";